import React from "react";
import styles from "./IdleSession.module.css";

export const formatCountdown = (totalSeconds) => {
  const seconds = Math.max(0, Math.floor(totalSeconds || 0));
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
};

// Seconds at or below which the countdown turns red and starts pulsing.
export const URGENT_SECONDS = 30;

// Circular countdown - the ring drains as `secondsLeft` approaches 0.
const CountdownRing = ({ secondsLeft, totalSeconds, size = 148, stroke = 10, showLabel = true }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const fraction = totalSeconds > 0 ? Math.min(Math.max(secondsLeft / totalSeconds, 0), 1) : 0;
  const urgent = secondsLeft <= URGENT_SECONDS;

  return (
    <div
      className={`${styles.ring} ${urgent ? styles.ringUrgent : ""}`}
      style={{ width: size, height: size }}
      role="timer"
      aria-live="off"
      aria-label={`${formatCountdown(secondsLeft)} until automatic sign-out`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          className={styles.ringTrack}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          className={styles.ringValue}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - fraction)}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      {showLabel && (
        <div className={styles.ringLabel}>
          <span className={styles.ringTime}>{formatCountdown(secondsLeft)}</span>
          <span className={styles.ringUnit}>{secondsLeft >= 60 ? "minutes" : "seconds"}</span>
        </div>
      )}
    </div>
  );
};

export default CountdownRing;
